import React, { SetStateAction, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  InputLabel,
  Divider,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { useStyles } from './styles';
import { Agent, MissionCar } from '../../@types/records';

interface IProps {
  agentsAndVehicles: { agents: Agent[]; missionCars: MissionCar[] };
  setAgentsAndVehicles: React.Dispatch<
    SetStateAction<{ agents: Agent[]; missionCars: MissionCar[]; _localId: string }>
  >;
  desabilitado?: boolean;
}

const AgentsVehiclesForm: React.FC<IProps> = ({
  agentsAndVehicles,
  setAgentsAndVehicles,
  desabilitado,
}) => {
  const classes = useStyles();
  const [agents, setAgents] = useState<Agent[]>(agentsAndVehicles.agents);
  const [missionCars, setMissionCars] = useState<MissionCar[]>(
    agentsAndVehicles.missionCars,
  );

  useEffect(() => {
    setAgents(agentsAndVehicles.agents);
    setMissionCars(agentsAndVehicles.missionCars);
  }, [agentsAndVehicles]);

  const handleAgentNumberChange = (index: number, value: string) => {
    const list = [...agents];
    list[index].Matrícula = value.replace(/\D/g, '');
    setAgents(list);
  };

  const handleMissionCarIDChange = (index: number, value: string) => {
    const list = [...missionCars];
    list[index].id = value;
    setMissionCars(list);
  };

  return (
    <Accordion className={classes.accordionContainer}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Agentes e viaturas</Typography>{' '}
      </AccordionSummary>
      <AccordionDetails
        style={{ display: 'flex', flexDirection: 'column', alignContent: 'center' }}
      >
        <Grid container spacing={3} className={classes.agentsDiv}>
          {agents.map((agent, index) => {
            return (
              <Grid item xs={12} sm={12} md={6} key={agent._localId}>
                <div className={classes.inputContainer}>
                  <InputLabel className={classes.label}>
                    Matrícula do {index + 1}º agente
                  </InputLabel>
                  <input
                    name={`Matrícula do ${index + 1}º agente`}
                    className={classes.input}
                    onChange={(event) =>
                      handleAgentNumberChange(index, event.target.value)
                    }
                    onBlur={() =>
                      setAgentsAndVehicles((prev) => {
                        return { ...prev, agents };
                      })
                    }
                    value={agent.Matrícula}
                    placeholder={`Matrícula do ${index + 1}º agente`}
                    disabled={desabilitado}
                  />
                </div>
              </Grid>
            );
          })}
        </Grid>
        <Grid container spacing={3} className={classes.agentsDiv}>
          {missionCars.map((missionCar, index) => {
            return (
              <Grid item xs={12} sm={12} md={6} key={missionCar._localId}>
                <div className={classes.inputContainer}>
                  <InputLabel className={classes.label}>
                    ID da {index + 1}ª Viatura
                  </InputLabel>
                  <input
                    name={`ID da ${index + 1}ª viatura`}
                    className={classes.input}
                    onChange={(event) =>
                      handleMissionCarIDChange(index, event.target.value)
                    }
                    onBlur={() =>
                      setAgentsAndVehicles((prev) => {
                        return { ...prev, missionCars };
                      })
                    }
                    value={missionCar.id}
                    placeholder={`ID da ${index + 1}ª viatura`}
                    disabled={desabilitado}
                  />
                </div>
              </Grid>
            );
          })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default AgentsVehiclesForm;
